<!-- <div id="alpha-linkbar-styles">
<div class="alpha-linkbar-cnt">
  <span *ngFor="let link of numeroAlpha; let i = index" class="alpha-link-item">
    <a [routerLink]="[]" [class.active]="i == activeIndex" (click)="selectNumeroAlpha(i)">{{link}}</a>
    <span *ngIf="i < numeroAlpha.length-1"></span>
  </span>
</div>
</div> -->

<ul id="alphanavbar" class="alpha-navbar">
  @for (link of numeroAlpha; track link; let i = $index) {
    <li>
      <div class="notactiveclass"
        [class.active]="i == activeIndex"
        [id]="link.name"
        tooltip="'Filter apps starts with alphabet '+link.name"
        [attr.aria-label]="'Filter apps starts with alphabet '+link.name"
        role="button"
        tabindex="0"
        (click)="selectNumeroAlpha(i)"
        (keydown.enter)="selectNumeroAlpha(i)"
        (keydown.space)="$event.preventDefault(); selectNumeroAlpha(i)">
        {{ link.name }}
      </div>
      @if (i < numeroAlpha.length - 1) {
        <span></span>
      }
      <!-- <a  [class.active]="i == activeIndex"
      [disabled]="link.editable"
      [id]="link.name"
    (click)="selectNumeroAlpha(i)">{{link.name}}</a>
    <span *ngIf="i < numeroAlpha.length-1"></span> -->

    <!-- <mat-link [class.active]="i == activeIndex"
    [class.disabled]="link.editable ? true : false "
    (click)="selectNumeroAlpha(i)"
    [apiReturned]="link.editable ? true : false"
    [route]="[]">
  </mat-link> -->

</li>
}
</ul>